/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const chain = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M10.79 3.36c.425-.233.91-.36 1.41-.36.743 0 1.455.28 1.98.778.525.498.82 1.174.82 1.878s-.295 1.38-.82 1.878l-2.97 2.817a2.873 2.873 0 0 1-1.87.777 2.896 2.896 0 0 1-1.93-.633 2.619 2.619 0 0 1-.962-1.709 2.52 2.52 0 0 1 0-.623m3.082 0a2.52 2.52 0 0 0 .023-.769 2.619 2.619 0 0 0-.963-1.708 2.896 2.896 0 0 0-1.93-.634 2.873 2.873 0 0 0-1.87.778L1.82 8.648A2.589 2.589 0 0 0 1 10.526c0 .704.295 1.38.82 1.878a2.879 2.879 0 0 0 1.98.778c.563 0 1.11-.161 1.57-.457"
    />
  </svg>
)
export default chain
